import { BookOpen, FileText, X } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useInterventionPanelStore } from "@/app/store/intervention-panel.store";
import { maskNameKeepLast } from "@/pages/medical/screens/home/utils";
import { ManualPane } from "./ManualPane";
import { RecordForm } from "./RecordForm";

export function InterventionPanel({
	onScheduleAdd,
}: {
	onScheduleAdd?: () => void;
}) {
	const { t } = useTranslation(["medical", "common"]);
	const { open, patient, note, closePanel } = useInterventionPanelStore();
	const isView = !!note;

	if (!open || !patient) return null;

	return (
		<aside className="intervention-panel" data-open="true">
			<div className="intervention-panel__main">
				{/* Header */}
				<div className="intervention-panel__head">
					<div>
						<h3>
							{isView
								? t("patients.intervention.panel.viewTitle")
								: t("patients.intervention.panel.newTitle")}
						</h3>
						<p className="text-[13px] text-[var(--muted-foreground)] mt-1">
							{maskNameKeepLast(patient.name)} ({patient.mrn})
						</p>
					</div>
					<button
						type="button"
						className="modal__close"
						onClick={closePanel}
						aria-label={t("common:actions.close")}
					>
						<X size={20} />
					</button>
				</div>

				{/* Split: Record | Manual */}
				<div className="intervention-panel__split">
					{/* Record column */}
					<div className="intervention-panel__col intervention-panel__col--record">
						<div className="ivp-col-head">
							<FileText size={15} />
							<span>{t("patients.intervention.panel.record")}</span>
						</div>
						<div
							className="intervention-panel__pane intervention-panel__pane--record"
							role="region"
							aria-label={t("patients.intervention.panel.record")}
						>
							<div className="intervention-panel__body">
								<RecordForm
									key={`${note?.id ?? "new"}-${patient.uid}`}
									note={note}
									onScheduleAdd={onScheduleAdd}
								/>
							</div>
						</div>
					</div>

					{/* Manual column */}
					<div className="intervention-panel__col">
						<div className="ivp-col-head">
							<BookOpen size={15} />
							<span>{t("patients.intervention.panel.manual")}</span>
						</div>
						<div
							className="intervention-panel__pane intervention-panel__pane--manual"
							role="region"
							aria-label={t("patients.intervention.panel.manualAria")}
						>
							<ManualPane />
						</div>
					</div>
				</div>
			</div>
		</aside>
	);
}
